import { NeutralColor } from "node-library/dist/colors";

interface Props {
	title: string;
	customHeaderClass?: string;
	button: React.ReactNode;
	items: Array<React.ReactNode>;
}

export default function CopyEmailSection(props: Props) {
	return (
		<>
			<div
				className={`submission-confirm-user-info-row typography-body-02 ${
					props.customHeaderClass || ""
				}`}
				style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
			>
				<div
					className="submission-confirm-info-row-title"
					style={{ color: NeutralColor.NEUTRAL_GREY_900 }}
				>
					{props.title}
				</div>
				<div className="submission-confirm-info-row-info">{props.button}</div>
			</div>
			<div className="test-report-info-email-container">{props.items}</div>
		</>
	);
}
